module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAJBJREFUOBFjYBjsoKKi4hayG5mQORSyVZH1U9NgZHMZWFB4aJzKysqt////90IThnMZGRm3tbe3e8MFkBh4XYzPUJAZ+OTxGozkAJKZw8xgUOQQCIOtBOQplwZmkP/IptAsjFHSMaF0i+wiEJvodIwvXaIbCuLjU0+zoBjiBhORbtGDehilY2pG3m30cKIJHwDMHigv1LwLOAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_AlignRight_disabled.png
// module id = 308
// module chunks = 0